export const IS_HTTP_PROTOCOL = /^https?:\/\//i;
